import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../common/sidebar-component';
import ContributorResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import useGetSimilarContributors from '../../../services/contributors/similar-service';
import NanoProfile from '../common/nano-profile';

const ContributorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function SimilarContributors({ profile }) {
  const { dispatch } = React.useContext(ContributorResultsContext);
  const [{ data }, executeQuery] = useGetSimilarContributors(profile.id, 3);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'contributors.length')) {
      dispatch({ type: 'setSimilarContributors', payload: data.contributors });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'contributors.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title="contributors similar to"
        query={profile.name}
      />
      <ContributorsContainer>
        {data.contributors.map(p => (
          <NanoProfile key={`similar-contributor-${p.id}`} profile={p} dark small />
        ))}
      </ContributorsContainer>
    </SidebarComponent>
  );
}

SimilarContributors.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    organisation: PropTypes.string,
  }).isRequired,
};
